import "@/App.css";
import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import LandingPageV2 from "./pages/LandingPageV2";
import ArchivePage from "./pages/ArchivePage";
import EmbedWidget from "./pages/EmbedWidget";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import MockupSkate from "./pages/mockups/MockupSkate";
import MockupEditorial from "./pages/mockups/MockupEditorial";
import MockupArcade from "./pages/mockups/MockupArcade";
import ShareCardPreview from "./pages/ShareCardPreview";
import RenderShareCard from "./pages/RenderShareCard";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-black/60 font-mono-disp">
        Sprawdzanie sesji...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

// Landing page is no-scroll; admin and history pages allow scroll.
function ScrollClassController() {
  const location = useLocation();
  useEffect(() => {
    const allowScroll =
      location.pathname.startsWith("/admin") ||
      location.pathname.startsWith("/historia") ||
      location.pathname.startsWith("/widget") ||
      location.pathname.startsWith("/preview") ||
      location.pathname === "/v2";
    if (allowScroll) {
      document.documentElement.classList.add("allow-scroll");
      document.body.classList.add("allow-scroll");
    } else {
      document.documentElement.classList.remove("allow-scroll");
      document.body.classList.remove("allow-scroll");
    }
  }, [location.pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollClassController />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/v2" element={<LandingPageV2 />} />
            <Route path="/historia" element={<ArchivePage />} />
            <Route path="/widget" element={<EmbedWidget />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/preview/skate" element={<MockupSkate />} />
            <Route path="/preview/editorial" element={<MockupEditorial />} />
            <Route path="/preview/arcade" element={<MockupArcade />} />
            <Route path="/preview/share-card" element={<ShareCardPreview />} />
            <Route path="/render/share-card" element={<RenderShareCard />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="light"
          position="top-center"
          toastOptions={{
            style: {
              background: "#ffffff",
              color: "#121814",
              border: "1px solid #2e6c2e",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
